import { Box, Button, css } from '@mui/material'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useEffect, useRef, useState } from 'react'
import { useMQ } from '../hooks/useMQ'
import useOnScreen from '../utils/useOnScreen'
import { HumaScrollAnimation } from './HumaScrollAnimation'
import PayfiImage from './images/payfi-static.png'

export function Payfi() {
  const { isXsSize, isSmSize } = useMQ()
  const ref = useRef<HTMLDivElement>(null)
  const [isPaused, setIsPaused] = useState<boolean>(true)
  const isVisible = useOnScreen(ref)

  useEffect(() => {
    if (isVisible && isPaused) {
      setIsPaused(false)
    }
  }, [isPaused, isVisible])

  const styles = {
    payfiImageContainer: css`
      display: flex;
      justify-content: center;
      width: 100%;
      max-width: 400px;
    `,
    payfiImage: css`
      object-fit: contain;
      width: 100%;
    `,
    payfiTextWrapper: css`
      display: flex;
      justify-content: center;
      flex-direction: column;
    `,
    payfiText: css`
      max-width: 780px;
      font-size: ${isXsSize ? '14px' : '24px'};
      margin-top: 24px;
      letter-spacing: 0.15px;
      color: #b8b8b8;
      font-weight: 300;
      line-height: 120%;
    `,
    payfiButtonWrapper: css`
      margin-top: 24px;
    `,
    payfiButton: css`
      padding-left: 24px;
      padding-right: 24px;
      height: ${isXsSize ? '42px' : '48px'};
      width: ${isSmSize ? '100%' : 'auto'};
    `,
    payfiButtonText: css`
      margin-right: 16px;
    `,
    payfiTextTitle: css`
      font-family: 'Red-Hat-Display';
      font-weight: 700;
      font-size: ${isSmSize ? '32px' : '34px'};
      text-align: ${isSmSize ? 'center' : 'left'};
      line-height: 123.5%;
      letter-spacing: 0.25px;
      background: linear-gradient(90.27deg, #ffffff 0.23%, #999999 99.89%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      margin-top: ${isSmSize ? '12px' : '0px'};
    `,
    rightContainer: css`
      display: flex;
      flex-direction: column;
      padding: ${isSmSize ? '0px' : '0 64px'};
    `,
    container: css`
      display: flex;
      flex-direction: ${isSmSize ? 'column' : 'row'};
      align-items: center;
      max-width: 925px;
      margin: 0 auto;
      padding: ${isSmSize ? '40px' : '0px'};
      background: ${isSmSize ? 'rgba(0, 0, 0, 0.7) !important' : 'none'};
      backdrop-filter: ${isSmSize ? 'blur(32px)' : 'none'};
      border-radius: ${isSmSize ? '16px' : '0px'};
      border: ${isSmSize ? '1px solid #1b1b1b' : 'none'};
    `,
  }

  return (
    <HumaScrollAnimation>
      <Box marginTop='100px'>
        <Box css={styles.container}>
          <Box css={styles.payfiImageContainer} ref={ref}>
            <img css={styles.payfiImage} src={PayfiImage} alt='Payfi' />
          </Box>
          <Box css={styles.rightContainer}>
            <Box css={styles.payfiTextWrapper}>
              <Box css={styles.payfiTextTitle}>
                Modern payments need modern infrastructure.
              </Box>
              <Box css={styles.payfiText}>
                The PayFi Stack delivers a modular, six-layer framework to
                accelerate payments — spanning high-speed chains, stablecoins,
                custody, compliance, financing, and applications.
              </Box>
            </Box>
            <Box css={styles.payfiButtonWrapper}>
              <Button
                variant={isSmSize ? 'outlined' : 'contained'}
                size='large'
                css={styles.payfiButton}
                href='https://blog.huma.finance/understanding-the-payfi-stack-transforming-financial-infrastructure'
                target='_blank'
              >
                <Box css={styles.payfiButtonText}>Learn More</Box>
                <ArrowForwardIcon></ArrowForwardIcon>
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </HumaScrollAnimation>
  )
}
